import { render, staticRenderFns } from "./buy-item-free-item-condition.vue?vue&type=template&id=70f381c6&scoped=true&"
import script from "./buy-item-free-item-condition.vue?vue&type=script&lang=js&"
export * from "./buy-item-free-item-condition.vue?vue&type=script&lang=js&"
import style0 from "./buy-item-free-item-condition.vue?vue&type=style&index=0&id=70f381c6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f381c6",
  null
  
)

export default component.exports